export default __webpack_public_path__ + "static/media/CapDownArrowMobile.44f4abc8.svg";